import React from 'react';
import PropTypes from 'prop-types';
import { FieldInputProps } from '../Constants/ReduxFormPropTypes';
import SelectList from './SelectList';

const SelectWrap = ({ options, input }) => (
  <SelectList options={options} input={input} />
);

SelectWrap.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    }),
  ).isRequired,
  input: FieldInputProps.isRequired,
};

export default SelectWrap;
